import { ReactNode } from 'react'

import { Info } from 'lucide-react'

import { FormControl, FormDescription, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

interface FormFieldWrapperProps {
  label?: string
  tooltip?: string
  desc?: string
  children: ReactNode
  required?: boolean
}

export function FormFieldWrapper({ label, tooltip, desc, children, required = false }: FormFieldWrapperProps) {
  return (
    <FormItem>
      {(label || tooltip) && (
        <FormLabel className='flex items-center gap-1.5'>
          {label}
          {tooltip && (
            <Tooltip delayDuration={300}>
              <TooltipTrigger
                type='button'
                className='focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none'
              >
                <Info className='text-muted-foreground h-3.5 w-3.5' aria-hidden='true' />
              </TooltipTrigger>
              <TooltipContent className='max-w-[200px] text-xs'>{tooltip}</TooltipContent>
            </Tooltip>
          )}
          {required && <span className='text-destructive'>*</span>}
        </FormLabel>
      )}
      <FormControl>{children}</FormControl>
      {desc && <FormDescription>{desc}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}
